import { render } from "./CombinationTherapy2.vue?vue&type=template&id=b3c06a6c"
import script from "./CombinationTherapy2.vue?vue&type=script&lang=js"
export * from "./CombinationTherapy2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/CombinationTherapy2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b3c06a6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b3c06a6c', __exports__)) {
    api.reload('b3c06a6c', __exports__)
  }
  
  module.hot.accept("./CombinationTherapy2.vue?vue&type=template&id=b3c06a6c", () => {
    api.rerender('b3c06a6c', render)
  })

}


export default __exports__